
///Worn limit
export class UCWornLimitGenericIdNameVM {
  public Id: number;
  public Name: string;
  public Desc: string;
  public CompTypeId: number;

}

export class UC_WornLimitInfoVM {

  public Method: number;
  public MakeId: number;
  public MakeName: string;
  public MethodName: string;
  public PartNo: string;
  public USCOPartNo: string;

  public Component: string;
  public ComprtType: string;
  public SteppedData: UCStepped_ITM_WornLimitsVM[]
  public InflectionData: UCInflection_CAT_WornLimitsVM[]
  public PolynomialData: UCPolynomial_KOMATSU_WornLimitsVM[]
  public LinearData: UCLinear_LIEBHERR_WornLimitsVM[]

}

export class UCStepped_ITM_WornLimitsVM {
  public Id: number;
  public CompartId: number
  public toolId: number
  public ToolName: string;
  public startDepeth_New: number
  public wearDepth_10: number
  public wearDepth_20: number
  public wearDepth_30: number
  public wearDepth_40: number
  public wearDepth_50: number
  public wearDepth_60: number
  public wearDepth_70: number
  public wearDepth_80: number
  public wearDepth_90: number
  public wearDepth_100: number
  public wearDepth_110: number
  public wearDepth_120: number

  public startDepeth_Mi: number
  public wearDepth_10_Mi: number
  public wearDepth_20_Mi: number
  public wearDepth_30_Mi: number
  public wearDepth_40_Mi: number
  public wearDepth_50_Mi: number
  public wearDepth_60_Mi: number
  public wearDepth_70_Mi: number
  public wearDepth_80_Mi: number
  public wearDepth_90_Mi: number
  public wearDepth_100_Mi: number
  public wearDepth_110_Mi: number
  public wearDepth_120_Mi: number
  public MSPoId: number
  public Starting_Dim: number
  public Worn_100: number

}
export class UCInflection_CAT_WornLimitsVM {
  public Id: number
  public CompartId: number
  public toolId: number
  public ToolName: string;

  public hi_InflectionPoint: number
  public hi_Slope_1: number
  public hi_Intercept_1: number
  public hi_Slope_2: number
  public hi_Intercept_2: number


  public mi_InflectionPoint: number
  public mi_Slope_1: number
  public mi_Intercept_1: number
  public mi_Slope_2: number
  public mi_Intercept_2: number

  public adjust_base: number
  public Slope: number
  public MSPointId: number
  public Starting_Dim: number
  public Worn_100: number
}
export class UCPolynomial_KOMATSU_WornLimitsVM {
  public Id: number
  public CompartId: number
  public toolId: number
  public ToolName: string;
  public impact_slope: number
  public normal_slope: number

  public impact_intercept: number
  public normal_intercept: number


  public impact_secondOrder: number
  public normal_secondOrder: number

  public MSPointId: number
  public Starting_Dim: number
  public Worn_100: number

  public slope_impact: number
  public slope_normal: number

}
export class UCLinear_LIEBHERR_WornLimitsVM {
  public Id: number
  public CompartId: number
  public toolId: number
  public ToolName: string;
  public impact_slope: number
  public normal_slope: number

  public impact_intercept: number
  public normal_intercept: number


  public MSPointId: number

  public Starting_Dim: number
  public Worn_100: number

}

export class USCOPopulateData {
  public CompType: string;
  public Make: string;
  public Models: string;


}

export class USCO_PartInfoVM {
  public Id: number;

  public USCOPartNo: string
  public Description: string

  public Make: string

  public CompartType: string

  public Model: string

  public Tool: string

  public CalcMethod: string

  public StartinDim: number;
  public Dim100Perc: number;
}